import OSTRYX_PROMO from "../../assets/videos/OstryxPromo1.mp4";
import React from "react";

const PromoVideo = () => {
    return (
        <>
           <video 
            src={OSTRYX_PROMO} 
            autoPlay 
            muted 
            loop 
            playsInline
            style={{
                width: "100%",
                height: "100%",
                objectFit: "fill",
                borderRadius: "20px"
            }}
        />
        </>
    );
};

export default PromoVideo;